import React from 'react';

import MediaBigFS from './component';

export default React.memo(MediaBigFS);
